<p-drawer
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  position="right"
  styleClass="manage-team-drawer"
  [modal]="true"
  [closeOnEscape]="true"
  libDrawerResize
  drawerResizeKey="manage-team"
>
  <ng-template pTemplate="header">
    <h2 class="drawer-title">
      {{ mode() === 'edit' ? 'Edit team member' : 'Add a recruiter' }}
    </h2>
  </ng-template>

  <ng-template pTemplate="content">
    <section class="team-form">

      @if (mode() === 'add') {
        <p class="section-hint">
          Invite a colleague to your company. They'll receive an email with a
          sign-in link and land on the app with the role you pick below.
        </p>
      }

      <div class="field-row">
        <div class="field">
          <label class="label" for="recruiter-first-name">
            First name <span class="required">*</span>
          </label>
          <input
            id="recruiter-first-name"
            pInputText
            type="text"
            required
            aria-required="true"
            [ngModel]="firstName()"
            (ngModelChange)="firstName.set($event)"
            placeholder="e.g. Jane"
          />
        </div>
        <div class="field">
          <label class="label" for="recruiter-last-name">
            Last name <span class="required">*</span>
          </label>
          <input
            id="recruiter-last-name"
            pInputText
            type="text"
            required
            aria-required="true"
            [ngModel]="lastName()"
            (ngModelChange)="lastName.set($event)"
            placeholder="e.g. Murphy"
          />
        </div>
      </div>

      <div class="field field--full">
        <label class="label" for="recruiter-email">
          Email <span class="required">*</span>
        </label>
        <input
          id="recruiter-email"
          pInputText
          type="email"
          required
          aria-required="true"
          [ngModel]="email()"
          (ngModelChange)="email.set(($event ?? '').trim())"
          [class.invalid]="emailInvalid() || duplicateEmail()"
          placeholder="e.g. jane@example.com"
        />
        @if (emailInvalid()) {
          <p class="hint hint--error" role="alert">
            Enter a valid email address (e.g. name&#64;example.com).
          </p>
        } @else if (duplicateEmail()) {
          <p class="hint hint--error" role="alert">
            That email is already on your team.
          </p>
        }
      </div>

      <div class="field field--full">
        <label class="label" for="recruiter-role">Role</label>
        <p-select
          inputId="recruiter-role"
          [options]="roleOptions"
          [ngModel]="role()"
          (ngModelChange)="role.set($event)"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          styleClass="form-select"
        />
        <p class="hint">Admins can manage the team; Recruiters and Viewers can't.</p>
      </div>

      @if (!canSave()) {
        <ul class="hint muted blockers" role="list">
          @for (reason of blockers(); track reason) {
            <li>{{ reason }}</li>
          }
        </ul>
      }

      <div class="submit-row">
        <p-button
          type="button"
          label="Cancel"
          styleClass="cancel-btn"
          [text]="true"
          [disabled]="isSaving()"
          (click)="onVisibleChange(false)"
        />
        <p-button
          type="button"
          [label]="mode() === 'edit' ? 'Save changes' : 'Add recruiter'"
          [icon]="mode() === 'edit' ? 'pi pi-check' : 'pi pi-user-plus'"
          styleClass="add-recruiter-btn"
          [loading]="isSaving()"
          [disabled]="!canSave()"
          (click)="submit()"
        />
      </div>

    </section>
  </ng-template>
</p-drawer>
